const agentContractABI = JSON.parse(`[{
    "inputs": [{
      "internalType": "contract TexavieCoin",
      "name": "_tokenContract",
      "type": "address"
    }],
    "stateMutability": "nonpayable",
    "type": "constructor"
  }, {
    "anonymous": false,
    "inputs": [{
      "indexed": false,
      "internalType": "address",
      "name": "userAddress",
      "type": "address"
    }, {
      "indexed": false,
      "internalType": "uint256",
      "name": "value",
      "type": "uint256"
    }, {
      "indexed": false,
      "internalType": "uint256",
      "name": "balance",
      "type": "uint256"
    }],
    "name": "CoinsDeducted",
    "type": "event"
  }, {
    "anonymous": false,
    "inputs": [{
      "indexed": false,
      "internalType": "address",
      "name": "userAddress",
      "type": "address"
    }, {
      "indexed": false,
      "internalType": "uint256",
      "name": "value",
      "type": "uint256"
    }, {
      "indexed": false,
      "internalType": "uint256",
      "name": "balance",
      "type": "uint256"
    }],
    "name": "CoinsRewarded",
    "type": "event"
  }, {
    "inputs": [{
      "internalType": "address",
      "name": "_userAddress",
      "type": "address"
    }, {
      "internalType": "string",
      "name": "_email",
      "type": "string"
    }, {
      "internalType": "uint256",
      "name": "_numberOfCoins",
      "type": "uint256"
    }],
    "name": "deductCoinsFromUser",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }, {
    "inputs": [],
    "name": "getNumCoinsRewarded",
    "outputs": [{
      "internalType": "uint256",
      "name": "",
      "type": "uint256"
    }],
    "stateMutability": "view",
    "type": "function"
  }, {
    "inputs": [{
      "internalType": "string",
      "name": "_email",
      "type": "string"
    }],
    "name": "getUserBalanceByEmail",
    "outputs": [{
      "internalType": "uint256",
      "name": "",
      "type": "uint256"
    }],
    "stateMutability": "view",
    "type": "function"
  }, {
    "inputs": [{
      "internalType": "address",
      "name": "_userAddress",
      "type": "address"
    }, {
      "internalType": "string",
      "name": "_email",
      "type": "string"
    }, {
      "internalType": "uint256",
      "name": "_numberOfCoins",
      "type": "uint256"
    }],
    "name": "rewardCoinsToUser",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }]`)

export default agentContractABI
